<template>
  <div class="areroom">
    <div class="slide">
      <mySlide />
    </div>
    <div class="room-warp">
      <div style="padding-top: 20px;">
        <div class="csgo-title w1500" style="margin-bottom: 24px;">
          <div class="back-box flex flex-ac" @click="goBack">
            <i class="iconfont icon-back" style="margin-right: 8px" />
            <span>返回</span>
          </div>
          <div class="flex flex-ac flex-jc">
            <img src="@/assets/images/title-label.png" />
            <div class="t p-1">CS2&CSGO游戏的ROLL房</div>
            <img src="@/assets/images/title-label.png" />
          </div>
        </div>
        <div class="w1500">
          <div class="room-top flex flex-jsb">
            <div class="room-top-left">
              <div class="room-title-left">
                <img :src="roomData.img" class="roll-img" />
                <div>
                  <div class=" flex flex-jsb">
                    <span class="span1" v-if="roomData.type == 2">主播</span>
                    <span class="span1" v-if="roomData.type == 1">官方</span>
                    <span class="span2">{{ roomData.room_name }}</span>
                    <div class="is-price flex flex-ac">
                      <img src="@/assets/images/roll/gift.png" />
                      免费
                    </div>
                  </div>
                  <div class="flex flex-ac" style="padding-top: 20px">
                    <span>ROLL房总价值：</span>
                    <img src="@/assets/images/money.png" class="money-img" />
                    <span class="price">{{ price }}</span>
                  </div>
                </div>
              </div>
              <div class="tiao-box">
                <div class="error flex flex-ac"><i class="el-icon-warning-outline"></i>需要完成所有参加条件后，才能参加抽奖</div>
                <div class="tiao-li flex flex-ac">
                  <div class="flex-1">
                    {{ roomData.desc }}
                  </div>
                </div>
              </div>
            </div>
            <div class="room-top-right">
              <div class="countdown-box">
                <div v-if="roomData.status == 1">
                  <div class="label">ROLL房距离结束时间</div>
                  <div>
                    <countdown :end-time="roomData.run_lottery_time" />
                  </div>
                </div>
                <div v-else>
                  <div class="label">ROLL房开始时间：{{ roomData.run_lottery_time }}</div>
                  <div class="btn-warp btn-warp-d">
                    <div class="b">ROLL房已结束</div>
                  </div>
                </div>
              </div>
              <template v-if="roomData.status == 2">
              </template>
              <template v-else-if="roomData.has_join == 1">
                <div class="btn-warp">
                  <div class="b">您已加入房间</div>
                </div>
              </template>
              <template v-else-if="roomData.status == 1">
                <div class="btn-warp" @click="addRoom">
                  <div class="b">
                    加入房间
                  </div>
                </div>
              </template>
              <div class="peoeple flex flex-ac flex-jc">
                <div class="icon flex-0 flex flex-ac flex-jc"><i class="el-icon-user-solid"></i></div>
                <span class="num6">参与人数：<span class="num">{{ roomData.person_num }}</span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line" v-if="roomData.status == 1">
        <div class="w1500">
          <div class="text">所有奖品</div>
        </div>
      </div>
      <div class="" v-if="roomData.status == 1">
        <div class="w1500P75">
          <div class="revisionSkin room-win">
            <ul>
              <li v-for="(item, index) in list" :key="index" class="skin-li" :class="parseColor(item)">
                <div class="li-div">
                  <div v-if="item.subclassName" class="ico">{{ item.subclassName }}</div>
                  <div class="bei">
                    <img :src="item.imageUrl" class="img_active" />
                  </div>
                  <div class="name p-1">{{ item.shortName }}</div>
                  <div class="sort">{{ item.exteriorName }}</div>
                  <div class="money-warp">
                    <img src="@/assets/images/money.png" class="money-img" />
                    <span>{{ item.price }}</span>
                  </div>
                  <div class="color-line" :style="'background-color:'+parseColor(item,'','color')"></div>
                </div>
              </li>
            </ul>
          </div>
          <div class="csgo-page">
            <el-pagination background layout="prev, pager, next" :pager-count="5" :current-page.sync="searchForm.page" :total="searchForm.totalSize" :page-size="searchForm.limit" @current-change="currentChange">
            </el-pagination>
          </div>
        </div>
      </div>
      <div v-if="roomData.status == 2" class="get-win">
        <div class="csgo-title">
          <div class="flex flex-ac flex-jc">
            <img src="@/assets/images/title-label.png" />
            <div class="t">中奖名单</div>
            <img src="@/assets/images/title-label.png" />
          </div>
        </div>
        <div class="w1500">
          <div class="win-con1 ">
            <div class="revisionSkin room-win">
              <ul>
                <li v-for="(item, index) in player_skin" :key="index" class="skin-li" :class="parseColor(item)">
                  <div class="win-warp">
                    <div class="win-name">
                      <img :src="item.player_img" class="player_img" />
                      <div class="p-1 player_name">{{ item.player_name || '未设置' }}</div>
                    </div>
                    <div class="li-div">
                      <div v-if="item.skin_subclassName" class="ico">{{ item.skin_subclassName }}</div>
                      <div class="bei">
                        <img :src="item.skin_img" class="img_active" />
                      </div>
                      <div class="name p-1">{{ item.skin_shortName }}</div>
                      <div class="sort">{{ item.skin_typeName }}</div>
                      <div class="money-warp">
                        <img src="@/assets/images/money.png" class="money-img" />
                        <span>{{ item.price }}</span>
                      </div>
                      <div class="color-line" :style="'background-color:'+parseColor(item,'','color')"></div>
                    </div>
                  </div>
                </li>
              </ul>
              <empty v-if="player_skin.length===0" :padding="30" description="暂无人员中奖"></empty>
            </div>
            <div v-if="player_skin.length!=0" class="csgo-page">
              <el-pagination background layout="prev, pager, next" :pager-count="5" :current-page.sync="playerSkinForm.page" :total="playerSkinForm.totalSize" :page-size="playerSkinForm.limit" @current-change="playerSkinCurrentChange">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="room-num">
        <div class="csgo-title">
          <div class="flex flex-ac flex-jc">
            <img src="@/assets/images/title-label.png" />
            <div class="t">参与者</div>
            <img src="@/assets/images/title-label.png" />
          </div>
        </div>
        <div class="w1500">
          <div class="num-list">
            <ul>
              <li v-for="(item, index) in player_list" :key="index">
                <img :src="item.img" class="play-img" />
                <div v-if="roomData.status == 2&&item.winning==1" class="player_name flex flex-jc flex-ac">
                  <span>+</span>
                  <img src="@/assets/images/money.png" class="money-img-ma" />
                  <span>{{ item.price }}</span>
                </div>
              </li>
            </ul>
            <empty v-if="player_list.length===0" :padding="30" description="暂无人员参与"></empty>
            <div v-if="player_list.length!=0" class="csgo-page">
              <el-pagination background layout="prev, pager, next" :pager-count="5" :current-page.sync="playerForm.page" :total="playerForm.totalSize" :page-size="playerForm.limit" @current-change="playerCurrentChange">
              </el-pagination>
            </div>
          </div>
        </div>

      </div>
    </div>
    <myhomebot />
    <div v-if="passState" class="csgo-mask login">
      <div class="reg-warp">
        <div class="btn-x" @click="passState=false">
          <img src="@/assets/images/btn-x.png" alt="" srcset="">
        </div>
        <div class="login-title" style="padding-top: 0;">输入房间口令</div>
        <div class="input">
          <el-input class="input1" v-model="password" placeholder="输入房间口令"></el-input>
        </div>
        <div class="btn-w-r-bg" @click="passAddRoom">
          <div class="btn-c-r">确认</div>
        </div>
      </div>
    </div>
    <div class="commonBg"></div>
  </div>
</template>

<script>
import myhomebot from "@/components/my_homebot.vue";
import mySlide from "@/g-components/my_slide.vue";
import countdown from "@/g-components/countdown.vue";
import empty from "@/g-components/empty.vue";
import { parseColor } from "@/assets/js/util.js";
import deepClone from "@/assets/js/deepClone.js";

export default {
  components: { myhomebot, mySlide, countdown, empty },
  data() {
    return {
      parseColor,
      password: "",
      passState: false,
      id: "",
      searchForm: {
        page: 1,
        totalSize: 0,
        limit: 12
      },
      playerSkinForm: {
        page: 1,
        totalSize: 0,
        limit: 12
      },
      playerForm: {
        page: 1,
        totalSize: 0,
        limit: 12
      },
      roomData: {},
      list: [],
      skinList: [],
      player_list: [],
      playerListY: [],
      price: 0,
      player_skin: [],
      playerSkinY: [],
      player_skin_price: 0,
    };
  },
  mounted() {
    //console.log(this.$route.query.id);
    this.id = this.$route.query.id;
    this.getRoom();
  },
  methods: {
    goBack() {
      this.$router.push({
        path: `/roll`,
      });
    },
    //加入房间
    addRoom() {
      if (!this.$store.state.loginState) {
        this.$store.commit("getLogin", true);
        return;
      }
      if (this.roomData.condition_type == 1 || this.roomData.condition_type == 3) {
        this.passState = true;
        return;
      }
      this.passAddRoom()
    },
    //密码加入房间
    passAddRoom() {
      if (this.roomData.condition_type == 1 || this.roomData.condition_type == 3) {
        if (this.password == '') {
          this.$message({
            message: "请输入房间口令",
            type: "warning",
          });
          return;
        }
      }
      let param = {
        free_room_id: this.id,
        password: this.password,
      };
      this.$doPost('/api/hall.Roll/joinRoom', param).then((res) => {
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.getRoom()
        this.passState = false
      }).catch(() => { })
    },
    //房间数据
    getRoom() {
      let param = {
        free_room_id: this.id,
        player_id: this.$store.state.id,
      };
      this.$doGet("/api/hall.Roll/detail", param).then((res) => {
        this.roomData = res.data
        // 参与人
        this.playerListY = res.data.player_list ? res.data.player_list : []
        this.playerForm.totalSize = this.playerListY.length
        let temp2 = deepClone(this.playerListY)
        this.player_list = temp2.slice((this.playerForm.page - 1) * this.playerForm.limit, this.playerForm.page * this.playerForm.limit)

        // 中奖的奖品
        this.playerSkinY = res.data.player_skin ? res.data.player_skin : []
        this.player_skin_price = 0
        for (let i = 0; i < this.playerSkinY.length; i++) {
          this.player_skin_price += Number(this.playerSkinY[i].price);
        }
        this.player_skin_price = this.player_skin_price.toFixed(2);
        this.playerSkinForm.totalSize = this.playerSkinY.length
        let temp = deepClone(this.playerSkinY)
        this.player_skin = temp.slice((this.playerSkinForm.page - 1) * this.playerSkinForm.limit, this.playerSkinForm.page * this.playerSkinForm.limit)

        // 这个是所有奖品
        this.price = 0
        this.skinList = res.data.skin_list.list ? res.data.skin_list.list : []
        for (let i = 0; i < this.skinList.length; i++) {
          this.price += Number(this.skinList[i].total);
        }
        this.price = this.price.toFixed(2)
        this.searchForm.totalSize = this.skinList.length
        let tempList = deepClone(this.skinList)
        this.list = tempList.slice((this.searchForm.page - 1) * this.searchForm.limit, this.searchForm.page * this.searchForm.limit)
      }).catch(() => { })
    },
    playerCurrentChange(val) {
      this.playerForm.page = val
      let temp2 = deepClone(this.playerListY)
      this.player_list = temp2.slice((this.playerForm.page - 1) * this.playerForm.limit, this.playerForm.page * this.playerForm.limit)
    },
    playerSkinCurrentChange(val) {
      this.playerSkinForm.page = val
      let temp = deepClone(this.playerSkinY)
      this.player_skin = temp.slice((this.playerSkinForm.page - 1) * this.playerSkinForm.limit, this.playerSkinForm.page * this.playerSkinForm.limit)
    },
    //分页
    currentChange(val) {
      this.searchForm.page = val
      let tempList = deepClone(this.skinList)
      this.list = tempList.slice((this.searchForm.page - 1) * this.searchForm.limit, this.searchForm.page * this.searchForm.limit)
    },
  },
};
</script>

<style lang="less" scoped>
.areroom {
  .room-top {
    padding: 50px 20px;
    background: #181c1f;
    margin-top: 20px;
    border-radius: 8px;
    border: 2px solid #1c3c4d;
    box-sizing: border-box;
    .room-top-left {
      min-width: 50%;
      .room-title-left {
        color: #fff;
        font-weight: bold;
        font-size: 24px;
        display: flex;
        align-items: flex-start;
        .roll-img {
          width: 96px;
          height: 96px;
          margin-right: 12px;
          border-radius: 50%;
        }
        .span1 {
          color: #ffc400;
          margin-right: 4px;
        }
        .is-price {
          color: #47b347;
          margin-left: 16px;
          img {
            width: 22px;
            height: 25px;
            margin-right: 8px;
          }
        }
      }
      .tiao-box {
        width: 100%;
        margin-top: 20px;
        padding: 18px;
        box-sizing: border-box;
        background: #2b2d3c;
        font-size: 14px;
        .error {
          color: #ff6060;
          i {
            margin-right: 8px;
          }
          margin-bottom: 20px;
        }
        .tiao-li {
          color: #fff;
        }
        .btn {
          background: #1b1c20;
          border-radius: 4px;
          border: 1px solid #ffc400;
          line-height: 30px;
          color: #ffc400;
          padding: 0 10px;
          cursor: pointer;
        }
        .btn-warp {
          width: 100%;
          padding: 3px 6px;
          border-radius: 8px 0 8px 0;
          background: rgba(101, 80, 6, 0.6);
          box-sizing: border-box;
          .b {
            cursor: pointer;
            border-radius: 8px 0 8px 0;
            background-color: #ffc400;
            line-height: 54px;
            text-align: center;
            font-size: 16px;
            color: #2b2e3c;
            font-weight: 600;
            width: 100%;
          }
        }
      }
      .room-img {
        padding-right: 20px;
        border-right: 1px solid #444659;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          border: 1px solid #e9b10e;
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }
        .span1 {
          margin-top: -13px;
          font-size: 13px;
          background-color: #e9b10e;
          padding: 0 6px;
          border-radius: 10px;
        }
        .span2 {
          margin-top: 10px;
          color: #c3c3e2;
        }
      }
      .room-int {
        margin-left: 20px;
        color: #c3c3e2;
        h5 {
          font-size: 16px;
          font-weight: 400;
        }
        span {
          font-size: 14px;
          color: #848492;
        }
      }
    }
    .room-top-right {
      color: #ffffff;
      .title {
        font-size: 24px;
        font-weight: bold;
      }
      .countdown-box {
        text-align: center;
        font-size: 14px;
        color: #fff;
        .label {
          margin-bottom: 8px;
        }
        .btn-warp {
          margin: 0 auto;
          width: 276px;
          padding: 3px 6px;
          border-radius: 8px 0 8px 0;
          background: rgba(69, 65, 65, 0.6);
          box-sizing: border-box;
          .b {
            cursor: pointer;
            border-radius: 8px 0 8px 0;
            background: #ff6060;
            line-height: 54px;
            text-align: center;
            font-size: 16px;
            color: #2b2e3c;
            font-weight: 600;
            width: 100%;
          }
        }
      }
      .btn-warp {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #e9b10e;
        border-radius: 5px;
        padding: 9px 22px;
        margin-top: 8px;
        &.btn-warp-d {
          background-color: #ddd;
        }
        img {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
        span {
          font-size: 15px;
          color: #1a1c24;
          font-weight: 600;
        }
      }
      .btn-warp:hover {
        cursor: pointer;
      }

      .btn-warp1 {
        font-size: 15px;
        color: #ccc;
      }
      .peoeple {
        margin-top: 8px;
        text-align: center;
        .icon {
          width: 20px;
          height: 20px;
          background: #2b2e3c;
          border-radius: 50%;
          margin-right: 4px;
          font-size: 14px;
          color: #ffc400;
          margin-right: 4px;
        }
        .num6 {
          font-size: 16px;
          color: #ffffff;
          .num {
            font-weight: bold;
          }
        }
      }
    }
  }
  .line {
    border-bottom: 1px solid #515352;
    .text {
      display: inline-block;
      padding: 20px;
      border-bottom: 1px solid #ffc403;
      color: #ffc403;
    }
  }
  .room-win {
    margin-top: 30px;
    .title {
      font-size: 24px;
      color: #ffffff;
      font-weight: bold;
      padding-left: 15px;
      .price {
        color: #ffc400;
      }
    }
    .win-con {
      margin-top: 20px;
    }
  }
  .get-win {
    padding: 50px 0px;
    box-sizing: border-box;
    .win-con1 {
      margin-top: 20px;
      border-radius: 8px;
      padding: 0 15px;
      border: 2px solid #1c3c4d;
      box-sizing: border-box;
      background: #181c1f;
      ul {
        li {
          .win-warp {
            .win-name {
              text-align: center;
              color: #fff;
              // margin-bottom: 24px;
              .player_img {
                width: 72px;
                height: 72px;
                border-radius: 50%;
                margin-bottom: 4px;
              }
              .player_name {
                font-weight: bold;
                font-size: 16px;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
  .room-num {
    padding: 50px 0;
    .num-list {
      margin-top: 20px;
      border-radius: 8px;
      border: 2px solid #1c3c4d;
      box-sizing: border-box;
      background: #181c1f;
      ul {
        display: flex;
        flex-wrap: wrap;
        padding: 15px 0;
        li {
          overflow: hidden;
          width: 102px;
          padding: 15px 0;
          color: #fff;
          text-align: center;
          .play-img {
            width: 72px;
            height: 72px;
            border-radius: 50%;
          }
        }
      }
    }
  }
  .revisionSkin {
    ul .skin-li {
      width: 16.66%;
    }
  }
}
// form-bg-2
.reg-warp {
  background: url(~@/assets/images/form-bg-2.png) no-repeat;
  background-size: 100% 100%;
}
</style>
